/**
 * Text input with voice support for Step 1
 */

import { Textarea } from "@/components/ui/textarea";
import VoiceInput from "@/components/VoiceInput";
import ListingDetailsForm from "@/components/ListingDetailsForm";
import { Mic } from "lucide-react";

export function TextInput({
  inputText,
  setInputText,
  contentLanguage,
  showListingDetails,
  setShowListingDetails,
  listingType,
  setListingType,
  listingDetails,
  setListingDetails,
  textPosition,
  setTextPosition
}) {
  return (
    <div className="space-y-4">
      <div>
        <label className="text-sm font-medium mb-2 block">Describe your idea</label>
        <div className="relative">
          <Textarea
            placeholder="Example: 'New summer collection launch - 30% off all dresses'"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            rows={3}
            className="input-base resize-none pr-14 text-base"
            autoFocus
            data-testid="input-text"
          />
          <div className="absolute right-3 top-3">
            <VoiceInput 
              onTranscription={(text) => setInputText(prev => prev ? prev + " " + text : text)}
              targetLanguage={contentLanguage}
              className="w-9 h-9"
            />
          </div>
        </div>
        <p className="text-xs text-viraly-muted mt-2 flex items-center gap-1">
          <Mic className="w-3 h-3" />
          Speak in any language - auto-translated
        </p>
      </div>
      
      {/* Listing Details */}
      <ListingDetailsForm
        showListingDetails={showListingDetails}
        setShowListingDetails={setShowListingDetails}
        listingType={listingType}
        setListingType={setListingType}
        listingDetails={listingDetails}
        setListingDetails={setListingDetails}
        textPosition={textPosition}
        setTextPosition={setTextPosition}
      />
    </div>
  );
}
